/* @flow */
import * as React from 'react';

// Hooks
import { useIntl } from 'react-intl';

// Styles
import styles from './BraindateParticipantsItemAvatar.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { getUserTitle } from 'src/shared/app/user/util/userUtils';
import { getUserFullName, getUserPath } from '@braindate/domain/lib/user/util';

// Components
import UserAvatar, {
  small,
} from 'src/shared/components/domain/user/avatar/UserAvatar';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import LinkWithChevron from 'src/shared/ui/component/link/LinkWithChevron';

const useStyles = createUseThemeStyles(styles);

type Props = {
  participant: User,
  onClose?: () => void,
};

const BraindateParticipantsItemAvatar = ({ participant, onClose }: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  const href = getUserPath(participant);

  return (
    <div className={classes.root}>
      <UserAvatar user={participant} variant={small} />

      <div className={classes.info}>
        <LinkWithChevron
          href={href}
          onClick={onClose}
          layoutClass={classes.link}
        >
          <span className={classes.name}>{getUserFullName(participant)}</span>
        </LinkWithChevron>

        <span className={classes.title}>{getUserTitle(participant, intl)}</span>
      </div>
    </div>
  );
};

export default React.memo<Props>(BraindateParticipantsItemAvatar);
